import * as React from "react";
import styled from "styled-components";

import { RenderMembershipFunc } from "./MembershipCardList";
import MembershipProfile, { MembershipProfileModels } from "./MembershipProfile";
import FeaturedMembershipCard, { FeaturedMembershipCardModels } from "./FeaturedMembershipCard";
import { media } from "../../common/utils/style";
import { Breakpoints } from "../../common/utils/media";

type Company = WtdModels.Partial<WtdModels.Company, "font_color_code">;
type CompanyMembership = WtdModels.Union<
  WtdModels.Partial<
    WtdModels.CompanyMembership,
    "id",
    {
      user: MembershipProfileModels["User"];
    }
  >,
  FeaturedMembershipCardModels["CompanyMembership"]
>;

export interface CompanyMembershipFeaturingsViewerModels {
  Company: Company;
  CompanyMembership: CompanyMembership;
}

interface Props {
  company: Company;
  featuredMemberships: CompanyMembership[];
  renderMembership?: RenderMembershipFunc;
}

interface State {
  selectedId?: number;
  expanded: boolean;
  profileHeight?: number;
}

export { RenderMembershipFunc };

class CompanyMembershipFeaturingsViewer extends React.PureComponent<Props, State> {
  private profileRef: HTMLElement | null = null;

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedId: props.featuredMemberships[0] && props.featuredMemberships[0].id,
      expanded: false,
    };
  }

  public onSelect = (membership: CompanyMembership) => {
    this.setState(
      {
        selectedId: membership.id,
        expanded: false,
      },
      () => {
        this.updateProfileHeight();
      }
    );
  };

  public onExpand = () => {
    this.setState(
      {
        expanded: true,
      },
      () => {
        this.updateProfileHeight();
      }
    );
  };

  public updateProfileHeight() {
    this.setState({
      profileHeight: this.profileRef!.scrollHeight,
    });
  }

  public render() {
    const { featuredMemberships, renderMembership } = this.props;
    const { selectedId, expanded, profileHeight } = this.state;
    const selectedMembership = featuredMemberships.find(member => member.id === selectedId);

    if (!featuredMemberships.length) {
      return null;
    }
    return (
      <Wrapper>
        <MembersWrapper>
          {featuredMemberships.map(membership => {
            return (
              <MemberWrapper key={membership.id}>
                {(renderMembership || this.renderMembershipDefault)({
                  membership,
                  key: String(membership.id),
                  isEntered: membership.id === selectedId,
                  onMouseEnter: () => this.onSelect(membership),
                })}
              </MemberWrapper>
            );
          })}
        </MembersWrapper>
        {selectedMembership && (
          <ProfileWrapper style={{ height: profileHeight || "" }}>
            <ProfileScrollInner innerRef={ref => (this.profileRef = ref)}>
              <MembershipProfile user={selectedMembership.user} expanded={expanded} onExpand={this.onExpand} />
            </ProfileScrollInner>
          </ProfileWrapper>
        )}
      </Wrapper>
    );
  }

  private renderMembershipDefault: RenderMembershipFunc = ({ membership, key, ...rest }) => {
    const { company } = this.props;
    if (!membership) {
      return null;
    }
    return <FeaturedMembershipCard key={key} membership={membership} lineColor={company.font_color_code} {...rest} />;
  };
}

export default CompanyMembershipFeaturingsViewer;

const Wrapper = styled.div`
  margin: 0 auto;
  position: relative;
  max-width: ${Breakpoints.medium}px;
  @media ${media.large} {
    margin: 0 80px;
  }
`;

const MembersWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
`;

const MemberWrapper = styled.div`
  width: calc(100% / 4);
`;

const ProfileWrapper = styled.div`
  overflow: hidden;
  transition: height 300ms linear 60ms;
`;

const ProfileScrollInner = styled.div``;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/CompanyMembershipFeaturingsViewer.tsx